import { useEffect, useState } from "react"

export const isAndroidWebview = () => {
  const navigator = window.navigator
  const userAgent = navigator.userAgent
  const normalizedUserAgent = userAgent.toLowerCase()
  const isAndroid = normalizedUserAgent.includes("android")

  return isAndroid && normalizedUserAgent.includes("; wv)")
}

export const useIsUnsupportedBrowser = () => {
  const [isUnsupportedBrowser, setIsUnsupportedBrowser] = useState(false)
  useEffect(() => {
    const isMetaInAppBrowser = /FBAN|FBAV|INSTAGRAM/i.exec(
      window.navigator.userAgent,
    )
    const isAppleWebKit = /AppleWebKit/i.exec(window.navigator.userAgent)

    let isSneakyFacebookScriptLoaded = false

    const scripts = document.getElementsByTagName("script")
    for (let i = 0; i < scripts.length; i++) {
      try {
        const e = scripts[i]
        if (e.getAttribute("src")) {
          const url = new URL(e.getAttribute("src")!)
          if (url.host && url.host === "connect.facebook.net") {
            isSneakyFacebookScriptLoaded = true
          }
        }
      } catch (err) {
        // ignore
      }
    }

    setIsUnsupportedBrowser(
      !!(
        (isMetaInAppBrowser && isAppleWebKit) ||
        isAndroidWebview() ||
        isSneakyFacebookScriptLoaded
      ),
    )
  }, [])

  return isUnsupportedBrowser
}
